import React from 'react';
import Team from '../components/Team';
import Download from '../components/Download';

// Team Page: Founders spotlight
const TeamPage = () => {
  return (
    <>
      <Team />
      <Download />
    </>
  );
};

export default TeamPage;